export const TypeNir = [
  'NIR',
  'NIA',
  'NTT',
] as const

export type TypeNir = typeof TypeNir[number]

export const TypeNirLibelle: {
  [key in TypeNir]: string
} = {
  NIR: 'NIR',
  NIA: 'NIA',
  NTT: 'NTT',
} as const
